import script from "./BaseRadioGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseRadioGroup.vue?vue&type=script&setup=true&lang=js"

import "./BaseRadioGroup.vue?vue&type=style&index=0&id=a3ebcf70&lang=scss"

const __exports__ = script;

export default __exports__